// removed by extract-text-webpack-plugin
module.exports = {"sider_menu":"app__css__app-pages-Assembly-siderMenu-__index__sider_menu","sider_menu_title":"app__css__app-pages-Assembly-siderMenu-__index__sider_menu_title","sider_menu_item":"app__css__app-pages-Assembly-siderMenu-__index__sider_menu_item","active":"app__css__app-pages-Assembly-siderMenu-__index__active"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Assembly/siderMenu/index.css
// module id = 1552
// module chunks = 0